import { useEffect, useState } from "react";

import IReportName from "../../contracts/IReportName";
import IReportAvailableColumn from "../../contracts/IReportAvailableColumn";
import IReportSelectedColumn from "../../contracts/IReportSelectedColumn";
import IAppStore from "../../store/contracts/IAppStore";
import IReportFilterCriteria from "../../contracts/IReportFilterCriteria";
import IUserDetails from "../../contracts/IUserDetails";
import IUserTenants from "../../contracts/IUserTenants";
import ISourceMap from "../../contracts/ISourceMap";
import ITaskImport from "../../contracts/ITaskImport";
import IQueuedReport from "../../contracts/IQueuedReport";
import { IWizardReportDetailsResponse } from "../../contracts/IWizardReportDetailsResponse";
import { IReportPivotSelection } from "../../contracts/IPivotSelection";



function useAppStoreHook(): IAppStore {

  //#region States
  const [accessToken, setAccessToken] = useState<string>(process.env.REACT_APP_DEV_ACCESS_TOKEN ?? '');

  const [userNameGlobally, setUserNameGlobally] = useState<string>();
  const [userIdGlobally, setUserIdGlobally] = useState<number>();
  const [tenantCode, setTenantCode] = useState<string>();
  const [userDetails, setUserDetails] = useState<IUserDetails>();
  const [userTenants, setUserTenants] = useState<IUserTenants[]>([]);

  const [reportList, setReportList] = useState<IReportName[]>([]);
  const [sourceList, setSourceList] = useState<ISourceMap[]>([]);

  const [taskImportList, setTaskImportList] = useState<ITaskImport[]>([]);
  const [queuedReportsList, setQueuedReportsList] = useState<IQueuedReport[]>([]);

  const [selReport, setSelReport] = useState<IReportName>();
  // const [selReportName, setSelReportName] = useState<string>();
  const [selReportCode, setSelReportCode] = useState<string>();
  const [isReportSelected, setIsReportSelected] = useState<boolean>(false);
  const [isReportChanged, setIsReportChanged] = useState<boolean>(false);


  const [dataSourceName, setDataSourceName] = useState<any>();
  const [defaultFilters, setDefaultFilters] = useState<IReportFilterCriteria[]>([]);
  const [currentFilters, setCurrentFilters] = useState<IReportFilterCriteria[]>([]);
  useEffect(() => setCurrentFilters([...defaultFilters]), [defaultFilters]);


  const [selReportData, setSelReportData] = useState<any>();
  const [selReportDetails, setSelReportDetails] = useState<IWizardReportDetailsResponse | null>(null);
  // ---
  const [defaultPivotSelections, setDefaultPivotSelections] = useState<IReportPivotSelection[]>([]);
  const [defaultSelectedColumns, setDefaultSelectedColumns] = useState<IReportSelectedColumn[]>([]);
  const [defaultAvailableColumns, setDefaultAvailableColumns] = useState<IReportAvailableColumn[]>([]);
  // ---
  const [currentSelectedColumns, setCurrentSelectedColumns] = useState<IReportSelectedColumn[]>([]);
  const [currentAvailableColumns, setCurrentAvailableColumns] = useState<IReportAvailableColumn[]>([]);

  useEffect(() => {
    setDefaultAvailableColumns(selReportDetails?.availableColumns || []);
    setDefaultSelectedColumns(selReportDetails?.selectedColumns || []);
    setDefaultFilters(selReportDetails?.selectedFilters || []);
    setDefaultPivotSelections(selReportDetails?.pivotSelections || []);
  }, [selReportDetails]);


  useEffect(() =>
    setCurrentSelectedColumns([...defaultSelectedColumns])
    , [defaultSelectedColumns]);


  useEffect(() => {
    setCurrentAvailableColumns([...defaultAvailableColumns]);
  }, [defaultAvailableColumns, defaultSelectedColumns]);

  //#endregion

  const clearSelections = () => {
    // cleanup
    setIsReportSelected(false);

    setSelReportDetails(null);
    setSelReportData([]);

    setDefaultAvailableColumns([]);
    setCurrentAvailableColumns([]);

    setDefaultSelectedColumns([]);
    setCurrentSelectedColumns([]);

    setDefaultFilters([]);
    setCurrentFilters([]);
  }

  useEffect(() => {
    clearSelections();
    setTimeout(() => {
      setSelReportCode(selReport?.reportCode);
      setIsReportChanged((selReport?.reportCode !== selReportCode));
      setIsReportSelected(selReport ? true : false)
    }, 100);

  }, [selReport])



  const cacheAccessToken = (value: string) => {
    setAccessToken(value);
  }

  //#region Utility-Functions

  const getReportByReportCode = (reportCode: string): IReportName | undefined => {
    return reportList.find(x => x.reportCode === reportCode);
  }

  const selectReportByReportCode = (reportCode: string) => {

    // cleanup
    clearSelections();

    let report = getReportByReportCode(reportCode);
    setSelReport(report);
  }

  const resetFilters = () => {
    setCurrentFilters([...defaultFilters]);
  }

  const resetColumns = () => {
    setCurrentSelectedColumns([...defaultSelectedColumns]);
  }

  const resetFiltersAndColumns = () => {
    resetFilters();
    resetColumns();
  }

  //#endregion


  return ({
    // --state and hooks
    userNameGlobally, setUserNameGlobally,
    userIdGlobally, setUserIdGlobally,
    tenantCode, setTenantCode,
    accessToken, cacheAccessToken,
    userDetails, setUserDetails,
    userTenants, setUserTenants,

    reportList, setReportList,
    sourceList, setSourceList,

    taskImportList, setTaskImportList,
    queuedReportsList, setQueuedReportsList,

    selReport, setSelReport, isReportSelected, isReportChanged, selReportCode,

    selReportData, setSelReportData,
    selReportDetails, setSelReportDetails,
    dataSourceName, setDataSourceName,

    defaultPivotSelections, setDefaultPivotSelections,

    defaultAvailableColumns, setDefaultAvailableColumns,
    currentAvailableColumns, setCurrentAvailableColumns,

    defaultSelectedColumns, setDefaultSelectedColumns,
    currentSelectedColumns, setCurrentSelectedColumns,

    defaultFilters, setDefaultFilters,
    currentFilters, setCurrentFilters,
    resetFilters, resetColumns, resetFiltersAndColumns,

    // ---functions
    getReportByReportCode, selectReportByReportCode,


  } as IAppStore);
}
export default useAppStoreHook;